var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallPrepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 4,
    fill: "#8097AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20.25C28.0716 20.25 26.1866 20.8218 24.5832 21.8932C22.9798 22.9645 21.7301 24.4873 20.9922 26.2688C20.2542 28.0504 20.0611 30.0108 20.4373 31.9021C20.8136 33.7934 21.7422 35.5307 23.1057 36.8943C24.4693 38.2579 26.2066 39.1865 28.0979 39.5627C29.9892 39.9389 31.9496 39.7458 33.7312 39.0078C35.5127 38.2699 37.0355 37.0202 38.1068 35.4168C39.1782 33.8134 39.75 31.9284 39.75 30C39.7473 27.415 38.7192 24.9366 36.8913 23.1087C35.0634 21.2808 32.585 20.2527 30 20.25ZM34.2806 28.2806L29.0306 33.5306C28.961 33.6004 28.8783 33.6557 28.7872 33.6934C28.6962 33.7312 28.5986 33.7506 28.5 33.7506C28.4014 33.7506 28.3038 33.7312 28.2128 33.6934C28.1218 33.6557 28.039 33.6004 27.9694 33.5306L25.7194 31.2806C25.5786 31.1399 25.4996 30.949 25.4996 30.75C25.4996 30.551 25.5786 30.3601 25.7194 30.2194C25.8601 30.0786 26.051 29.9996 26.25 29.9996C26.449 29.9996 26.6399 30.0786 26.7806 30.2194L28.5 31.9397L33.2194 27.2194C33.2891 27.1497 33.3718 27.0944 33.4628 27.0567C33.5539 27.019 33.6515 26.9996 33.75 26.9996C33.8486 26.9996 33.9461 27.019 34.0372 27.0567C34.1282 27.0944 34.2109 27.1497 34.2806 27.2194C34.3503 27.2891 34.4056 27.3718 34.4433 27.4628C34.481 27.5539 34.5004 27.6515 34.5004 27.75C34.5004 27.8485 34.481 27.9461 34.4433 28.0372C34.4056 28.1282 34.3503 28.2109 34.2806 28.2806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallPrepIcon);
export default __webpack_public_path__ + "static/media/install-prep-icon.4197fc05e7d1bfe091735ca642443562.svg";
export { ForwardRef as ReactComponent };